import React from 'react';
import HomeIcon from './HomeIcon';
import s from './HomeCollection.module.css';

export const COLLECTION_LINES = [['sun', 'Sun', 'sun'], ['optic', 'Optic', 'glasses']];

// A line's count as the Wall's switch shows it: a number once both reads answered, a quiet dot while they have not,
// a dash when a read failed (never a 0 that is not true).
export const countText = (t) => (t?.state === 'ready' ? Number(t.n).toLocaleString('en-US') : t?.state === 'failed' ? '–' : '·');
// A door's second line: "392 models", or a plain sentence while the number is not there (never "· models").
export const countPhrase = (t) => (t?.state === 'ready' ? `${Number(t.n).toLocaleString('en-US')} models` : t?.state === 'failed' ? 'Not loaded' : 'Counting…');
export const countLabel = (label, t) => `Open the ${label} wall${t?.state === 'ready' ? ` — ${Number(t.n).toLocaleString('en-US')} models` : ''}`;

// The tile's bottom row: a chip per line (opens that line's Wall) and Open Wall (opens the Wall on the open line).
export default function HomeCollectionLines({ collection, navigate }) {
  return (
    <nav className={s.lines} aria-label="Collection lines">
      {COLLECTION_LINES.map(([key, label, icon]) => {
        const total = collection?.lines?.[key];
        return (
          <button type="button" key={key} className={s.chip} data-test={`home-collection-${key}`} aria-label={countLabel(label, total)} onClick={() => navigate(`collection-${key}`)}>
            <HomeIcon name={icon} /><span>{label}</span><b>{countText(total)}</b>
          </button>
        );
      })}
      <button type="button" className={s.open} data-test="home-collection-open" onClick={() => navigate('collection-wall')}>Open Wall<span><HomeIcon name="arrow" /></span></button>
    </nav>
  );
}
